import { BrowserRouter, HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { Provider } from "react-redux";
import store from "./store/store";
import AppRoutes from "./routes/AppRoutes";
import moment from "moment";
import "moment/locale/es";
import SessionWatcher from "./utils/SessionWatcher";
import InternetWatcher from "./components/offline/InternetWatcher";
moment.locale("es");

function App() {
  return (
    <Provider store={store}>
      <HashRouter>
        <InternetWatcher />
        <SessionWatcher />
        <RouteScrollToTop />
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </HashRouter>
    </Provider>
  );
}

export default App;
